import { adminAuthApi } from "./admin/api";
import { authApi } from "./api";

// GET : Get files by userId
export const getFileListApi = (userId, type) => authApi.get(`/file/${userId}?type=${type}`)
export const adminGetFileListApi = (userId, type) => adminAuthApi.get(`/file/${userId}?type=${type}`)

// POST : Upload Files
export const uploadFilesApi = (formData, userId) =>
    authApi.post(
        `/file/${userId}`, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    )

// DELETE : Delete File
export const deleteFileApi = (fileId, fileKey) => authApi.delete(`/file/${fileId}?fileKey=${fileKey}`)